import Icon from "../../../components/AppIcon";
import { SocialPlatform } from "../types";

interface SocialMediaCardProps {
  platform: SocialPlatform;
}

const SocialMediaCard = ({ platform }: SocialMediaCardProps) => {
  const handleClick = () => {
    window.open(platform.link, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      onClick={handleClick}
      className="group relative p-6 rounded-lg border border-border bg-surface hover:border-primary/50 transition-all duration-300 hover:shadow-elevation-2 text-left w-full"
    >
      <div className="flex items-center gap-4 mb-4">
        <div
          className="p-3 rounded-lg transition-colors duration-300"
          style={{ backgroundColor: `${platform.color}15` }}
        >
          <Icon
            name={platform.icon}
            size={24}
            color={platform.color}
          />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
            {platform.name}
          </h3>
          <p className="text-sm text-muted-foreground">@{platform.username}</p>
        </div>
      </div>

      <div className="flex items-center justify-end">
        <Icon
          name="ExternalLink"
          size={16}
          className="text-muted-foreground group-hover:text-primary transition-colors duration-300"
        />
      </div>
    </button>
  );
};

export default SocialMediaCard;